import { createSlice } from "@reduxjs/toolkit";
import { getConfirmationCodeAction, resetPasswordAction } from "../actions/resetPassword.action";
import { resetPasswordResponse } from "../interfaces/interface";
import SnackBar from "common/components/ui/snackbar/SnackBar";

const initialState: resetPasswordResponse = {
  isConfirmationCodeRecvd: false,
  isPasswordReset: false,
  isLoading: false,
  error: null,
  isError: false,
  isSuccess: false,
};

const ResetPasswordSlice = createSlice({
  name: "resetPasswordSlice",

  initialState,

  reducers: {
    resetState: (state) => {
      state = { ...initialState };
      return state;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getConfirmationCodeAction.fulfilled, (state) => {
        const data = {
          type: "success",
          message: "Confirmation code successfully sent to the registered email.",
        };
        SnackBar(data);
        state.isConfirmationCodeRecvd = true;
        state.isPasswordReset = false;
        state.error = null;
        state.isSuccess = true;
        state.isError = false;
      })

      .addCase(getConfirmationCodeAction.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(getConfirmationCodeAction.rejected, (state, action) => {
        const data = {
          type: "error",
          message: "Error in sending confirmation code.",
        };
        SnackBar(data);
        state.isConfirmationCodeRecvd = false;
        state.isPasswordReset = false;
        state.error = action.error.message;
        state.isError = true;
      })
      .addCase(resetPasswordAction.fulfilled, (state) => {
        const data = {
          type: "success",
          message: "Password has been successfully reset.",
        };
        SnackBar(data);
        state.isPasswordReset = true;
        state.isConfirmationCodeRecvd = true;
        state.error = null;
        state.isSuccess = true;
        state.isError = false;
      })

      .addCase(resetPasswordAction.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(resetPasswordAction.rejected, (state, action) => {
        const data = {
          type: "error",
          message: "Error in resetting password",
        };
        SnackBar(data);
        state.isPasswordReset = false;
        state.isConfirmationCodeRecvd = false;
        state.error = action.error.message;
        state.isSuccess = true;
        state.isError = false;
      });
  },
});

export const { resetState } = ResetPasswordSlice.actions;

export default ResetPasswordSlice.reducer;
